module.exports = __webpack_public_path__ + "img/Bots-icon-white.8b840f78.svg";